export default __webpack_public_path__ + "static/miracle-mask-desktop-de1269cb19b58aabdd59781c8dc6f114.mp4";